import Box from '@mui/material/Box';
import { useThemeScoreColor } from '../../hooks';

export type MiniScoreType = {
  achievementPercentage: number;
  width?: number;
  height?: number;
};

export const MiniScore = ({
  achievementPercentage,
  width = 10,
  height = 10,
}: Readonly<MiniScoreType>) => {
  const color = useThemeScoreColor(achievementPercentage);

  return (
    <Box
      data-testid="tech-insights-mini-score"
      aria-label={`Achievement score: ${achievementPercentage}%`}
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: '50%',
        backgroundColor: color,
      }}
    />
  );
};
